<div class="container">
  <div class="row">
    <app-validate-email></app-validate-email>
  </div>
</div>

<app-notifications></app-notifications>
